export default "__VITE_ASSET__858c5418__"